import React from 'react';

const AddNewPlayerComp = ({
  toggleAddPlayerField, showAddPlayerField, savePlayer, newPlayerName,
  newPlayerDisplayName, handleNewPlayerInputChange,
}) => (
  <div className="team-section__inner-wrap">
    {showAddPlayerField && (
      <>
        <div className="team-section__player-input is-visible">
          <input
            type="text"
            name="newPlayerDisplayName"
            className="team-section__player-field m-0"
            placeholder="Enter display name"
            onChange={handleNewPlayerInputChange}
            value={newPlayerDisplayName}

          />
        </div>

        <div className="team-section__player-input mt-2 is-visible">
          <input
            type="text"
            name="newPlayerName"
            className="team-section__player-field"
            placeholder="Enter player's name"
            onChange={handleNewPlayerInputChange}
            value={newPlayerName}
          />
          {' '}
          <button
            type="button"
            className="btn btn-primary"
            onClick={savePlayer}
            disabled={newPlayerName.trim().length === 0 || newPlayerDisplayName.trim().length === 0}
          >
            Save
          </button>
        </div>
      </>
    )}

    <div
      className="team-section__add-btn"
      onClick={toggleAddPlayerField}
    >
      {showAddPlayerField ? 'Hide' : '+ Add player'}
    </div>
  </div>
);

export default AddNewPlayerComp;
